
import {Component, Vue} from 'vue-property-decorator';
import {readAdminGroups, readAdminRoles, readDefaultRoleSettings} from '@/store/admin/getters';
import {dispatchGetGroups} from "@/store/admin/actions";

@Component({})
export default class ImportGroupPermissions extends Vue {
  private dialog: boolean = false;
  private selectedGroup: any = null;

  public importFunction(val) {
    if (!this.selectedGroup) {
      return;
    }
    this.dialog = false;
    this.$emit('import-function', val);
  }

  private get groups() {
    return readAdminGroups(this.$store);
  }

  public async mounted() {
    if (!this.groups.length) {
      await dispatchGetGroups(this.$store);
    }
  }


}
